import * as React from "react";

type SvgProps = {
  props?: string;
};

export function ProcessorLogo(props: SvgProps) {
  return (
    <svg
      width={89}
      height={43}
      viewBox="0 0 89 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.844.469h2.812c7.667 0 12.24 2.594 13.719 7.781.5 1.708.75 3.667.75 5.875V43H23.844V.469zM.78 14.125C.781 9.521 1.833 6.145 3.937 4 6.25 1.646 10.021.469 15.25.469h2.813V43H.78V14.125zM71.594.469h2.812c7.667 0 12.24 2.594 13.719 7.781.5 1.708.75 3.667.75 5.875V43H71.594V.469zm-22.688 0H65.72V43H48.906V.469z"
        fill="#fff"
      />
    </svg>
  );
}
